import { render, staticRenderFns } from "./LearningUnitScoreDescriptionForm.vue?vue&type=template&id=361acfa4&"
import script from "./LearningUnitScoreDescriptionForm.vue?vue&type=script&lang=js&"
export * from "./LearningUnitScoreDescriptionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports